import React from 'react'
import { ShareButtons } from 'shared'

export const SharingContainer = ({ shareUrl }: { shareUrl: string }): JSX.Element => {
  return (
    <div className="bg-green-500 py-205 desktop:pt-6 desktop:pb-11" id="share">
      <div className="container">
        <div className="row">
          <div className="col-md-24 text-center">
            <h2 className="text-3xl text-white mb-4 desktop:mb-8">{I18n.t('projects.show.sharing.headline')}</h2>
            <div className="row">
              <div className="col-md-6 offset-md-9">
                <ShareButtons
                  platforms={['facebook', 'twitter', 'email', 'whatsapp', 'messenger']}
                  mobileOnly={['whatsapp', 'messenger']}
                  shape="round"
                  shareUrl={shareUrl}
                  gaLabel="ppp_sharing_module"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
